<template>
  <div>
  <el-dialog :visible.sync="visible" width="800px">
    <div slot="title" style="padding-bottom: 5px;">
      <span class="el-dialog__title">{{$store.getters.msgCount.msgNumber}} 条消息通知</span>
      <span style="margin-left: 10px; color: #1890FF;font-size: 13px;cursor: pointer;" @click="refresh">刷新</span>
      <button type="button" aria-label="Close" class="el-dialog__headerbtn">
        <i class="el-dialog__close el-icon el-icon-close"></i>
      </button>
    </div>
    <div class="tab-box">
      <el-tabs v-model="messageType" type="card" @tab-click="handleClick">
        <el-tab-pane label="全部" name="0" v-if=" account != 'mw' || $store.getters.user.userInfo.positionIds.length == 0 || ($store.getters.user.userInfo.positionIds.length >= 1 && $store.getters.user.userInfo.positionIds[0].id !=  '1ac95453b72747e1b101ca5baa00cbe7') "></el-tab-pane>
        <el-tab-pane name="1" v-if="account != 'mw' || $store.getters.user.userInfo.positionIds.length == 0 || ($store.getters.user.userInfo.positionIds.length >= 1 && $store.getters.user.userInfo.positionIds[0].id !=  '1ac95453b72747e1b101ca5baa00cbe7') ">
          <div slot="label" style="position: relative;">订单预警<span class="tabs-badge" v-if="$store.getters.msgCount.orderAlertcount && $store.getters.msgCount.orderAlertcount>0">{{$store.getters.msgCount.orderAlertcount>99?'99+':$store.getters.msgCount.orderAlertcount}}</span></div>
        </el-tab-pane>
        <el-tab-pane name="2" v-if="account != 'mw' || $store.getters.user.userInfo.positionIds.length == 0 || ($store.getters.user.userInfo.positionIds.length >= 1 && $store.getters.user.userInfo.positionIds[0].id !=  '1ac95453b72747e1b101ca5baa00cbe7') ">
          <div slot="label" style="position: relative;">审核申诉<span class="tabs-badge" v-if="$store.getters.msgCount.reviewAppealcount && $store.getters.msgCount.reviewAppealcount>0">{{$store.getters.msgCount.reviewAppealcount>99?'99+':$store.getters.msgCount.reviewAppealcount}}</span></div>
        </el-tab-pane>
        <el-tab-pane name="5">
          <div slot="label" style="position: relative;">财务预警<span class="tabs-badge" v-if="$store.getters.msgCount.kaipiaoCount && $store.getters.msgCount.kaipiaoCount>0">{{$store.getters.msgCount.kaipiaoCount>99?'99+':$store.getters.msgCount.kaipiaoCount}}</span></div>
        </el-tab-pane>
        <el-tab-pane name="3" v-if="account != 'mw' || $store.getters.user.userInfo.positionIds.length == 0 || ($store.getters.user.userInfo.positionIds.length >= 1 && $store.getters.user.userInfo.positionIds[0].id !=  '1ac95453b72747e1b101ca5baa00cbe7') ">
          <div slot="label" style="position: relative;">路内设备<span class="tabs-badge" v-if="$store.getters.msgCount.deviceOfflineInCount && $store.getters.msgCount.deviceOfflineInCount>0">{{$store.getters.msgCount.deviceOfflineInCount>99?'99+':$store.getters.msgCount.deviceOfflineInCount}}</span></div>
        </el-tab-pane>
        <el-tab-pane name="4" v-if="account != 'mw' || $store.getters.user.userInfo.positionIds.length == 0 || ($store.getters.user.userInfo.positionIds.length >= 1 && $store.getters.user.userInfo.positionIds[0].id !=  '1ac95453b72747e1b101ca5baa00cbe7') ">
          <div slot="label" style="position: relative;">路外设备<span class="tabs-badge" v-if="$store.getters.msgCount.deviceOfflineOutCount && $store.getters.msgCount.deviceOfflineOutCount>0">{{$store.getters.msgCount.deviceOfflineOutCount>99?'99+':$store.getters.msgCount.deviceOfflineOutCount}}</span></div>
        </el-tab-pane>
        <el-tab-pane name="6" v-if="account != 'mw' || $store.getters.user.userInfo.positionIds.length == 0 || ($store.getters.user.userInfo.positionIds.length >= 1 && $store.getters.user.userInfo.positionIds[0].id !=  '1ac95453b72747e1b101ca5baa00cbe7') ">
          <div slot="label" style="position: relative;">月卡过期未续费<span class="tabs-badge" v-if="$store.getters.msgCount.monthlyCardNotRenewalCount && $store.getters.msgCount.monthlyCardNotRenewalCount>0">{{$store.getters.msgCount.monthlyCardNotRenewalCount>99?'99+':$store.getters.msgCount.monthlyCardNotRenewalCount}}</span></div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="msg-list" id="msgList">
      <div class="msg-item" v-for="(item,index) in showDataList" :key="index" @click="goLink(item)">
        <div class="msg-icon">
          <i class="el-icon-message-solid"></i>
        </div>
        <div class="msg-content">
          <div class="msg-type">{{item.messageName}}<span>·</span>{{formatTime(dayjs(item.creatorTime).valueOf())}}</div>
          <div class="msg-tip">{{item.messageText}}</div>
        </div>
      </div>
      <div v-if="showDataList.length == 0" style="padding:40px 0;">
        <el-empty :image-size="40" description="未找到消息"></el-empty>
      </div>
    </div>
  </el-dialog>
  <MonthCardRenewalReview ref="monthCardRenewalReviewRef"></MonthCardRenewalReview>
  </div>
</template>

<script>
import MonthCardRenewalReview from '@/components/MonthCardRenewalReview'
import { getMsgList,getMsgCount,refreshMsgList,getDeviceOfflineList,delMsg } from '@/api/data'
import { formatTime } from '@/utils'
import Cookies from 'js-cookie'
import dayjs from 'dayjs'
export default {
  name: 'SystemMsg',
  components: {
    MonthCardRenewalReview
  },
  data(){
    return {
      visible: false,
      dataList:[],
      showDataList:[],
      showDeviceDataList:[],
      clickFlag:true,
      messageType:'',
      account:'',
      monthCardAuditData:null
    }
  },
  created() {
    this.account = Cookies.get('account')
    this.messageType = (this.account == 'mw' && this.$store.getters.user.userInfo.positionIds.length >= 1 && this.$store.getters.user.userInfo.positionIds[0].id == '1ac95453b72747e1b101ca5baa00cbe7')?'5':''
  },
  methods: {
    formatTime,
    dayjs,
    init(){
      this.visible = true;
      this.getData();
    },
    getDeviceData(type){
      getDeviceOfflineList({currentPage:1,pageSize:100,messageTypeList:6,deviceType:type,status: 0}).then(res =>{
        if(res.code == 200){
          if(res.data.list){
            this.showDataList = res.data.list;
          }else{
            this.showDataList = [];
          }
          
        }
      })
    },
    handleClick(e){
      if(this.messageType == '3'){
        this.getDeviceData(0);
      }else if(this.messageType == '4'){
        this.getDeviceData(1);
      }else if(this.messageType == '' || this.messageType == '0'){
        this.sendRquest(null);
      }else if(this.messageType == '1'){
        this.sendRquest('1,7,8,12');
      }else if(this.messageType == '2'){
        this.sendRquest('2,3,4,5');
      }else if(this.messageType == '5'){
        this.sendRquest('9,10');
      }else if(this.messageType == '6'){
        this.sendRquest('11');
      }
      document.getElementById('msgList').scrollTop = 0;
    },
    goLink(data){
      if(this.messageType == '3'){
        this.$router.push({ path: '/SysOperations/inRoad',query:{deviceNo:data.extend?JSON.parse(data.extend).sn:undefined}})
      }else if(this.messageType == '4'){
        this.$router.push({ path: '/SysOperations/outRoad',query:{deviceNo:data.extend?JSON.parse(data.extend).sn:undefined}})
      }else{
        if(data.messageType == 1){
          this.$router.push({ path: '/OrderManagement/OrderWarning',query:{id:data.businessId,type:1}})
        }else if(data.messageType == 8){
          this.$router.push({ path: '/OrderManagement/OrderWarning',query:{id:data.businessId,type:2}})
        }else if(data.messageType == 2){
          this.$router.push({ path: '/customer/carPhoneAudit',query:{id:data.businessId}})
        }else if(data.messageType == 3){
          this.$router.push({ path: '/OrderManagement/parkingOrderEditAudit',query:{id:data.businessId}})
        }else if(data.messageType == 4){
          this.$router.push({ path: '/customer/CarAuthenticationAudit',query:{id:data.businessId}})
        }else if(data.messageType == 5){
          this.$router.push({ path: '/ParkingOperations/customerComplain',query:{id:data.businessId}})
        }else if(data.messageType == 7){
          const params = {
            'restBack': this.$route.fullPath
          }
          this.$router.push({ path: '/OrderManagement/parkingRecordOrderInfo/' + data.businessId, query: params })
        }else if(data.messageType == 9){
          this.$router.push({ path: '/FinancialManagement/invoiceRecord'})
        }else if(data.messageType == 10){
          this.$router.push({ path: '/FinancialManagement/accountCheckMistake?batchNo='+data.messageText.split('“')[1].split('”')[0]})
          delMsg(data.id).then(res=>{});
        }else if(data.messageType == 11){
          this.showRenewalReview(data);
        }else if(data.messageType == 12){
          const params = {
            'restBack': this.$route.fullPath
          }
          this.$router.push({ path: '/OrderManagement/parkingRecordOrderInfo/' + data.businessId, query: params })
          delMsg(data.id).then(res=>{});
        }
      }
      if(data.messageType != 11){
        this.visible = false;
      }
    },
    showRenewalReview(data){
      this.$refs.monthCardRenewalReviewRef.initData(data);
    },
    refresh(){
      if(this.clickFlag){
        this.clickFlag = false;
        refreshMsgList().then(res=>{
          setTimeout(()=>{
            this.clickFlag = true;
          },700)
          if(res.code == 200){
            this.$message.success('刷新成功');
            this.getCount();
            this.getData();
          }
        })
      }
      
    },
    getCount(){
      getMsgCount({status:0}).then(res=>{
        if(res.code == 200){
          if(res.data){
            if(this.account == 'mw' && this.$store.getters.user.userInfo.positionIds.length >= 1 && this.$store.getters.user.userInfo.positionIds[0].id ==  '1ac95453b72747e1b101ca5baa00cbe7'){
              res.data.msgNumber = res.data.kaipiaoCount;
            }else{
              res.data.msgNumber = parseInt((res.data.orderAlertcount+res.data.reviewAppealcount+res.data.deviceOfflineInCount+res.data.deviceOfflineOutCount+res.data.kaipiaoCount).toFixed(0));
            }
            this.$store.dispatch('base/setMsgCount',res.data)
          }else{
            this.$store.dispatch('base/setMsgCount',{
              msgNumber:0,
              deviceOfflineInCount : 0,
              deviceOfflineOutCount : 0,
              deviceOfflineCount : 0,
              orderAlertcount: 0,
              reviewAppealcount: 0,
              kaipiaoCount:0
            })
          }
        }
      })
    },
    getData(){
      if(this.messageType == '3'){
        this.getDeviceData(0);
      }else if(this.messageType == '4'){
        this.getDeviceData(1);
      }else if(this.messageType == '' || this.messageType == '0'){
        this.sendRquest(null);
      }else if(this.messageType == '1'){
        this.sendRquest('1,7,8,12');
      }else if(this.messageType == '2'){
        this.sendRquest('2,3,4,5');
      }else if(this.messageType == '5'){
        this.sendRquest('9,10');
      }else if(this.messageType == '6'){
        this.sendRquest('11');
      }
      
    },
    sendRquest(type){
      getMsgList({status:0,pageSize:50,currentPage:1,messageTypeList:type}).then(res=>{
        if(res.code == 200){
          this.dataList = res.data.list
          this.showDataList = res.data.list
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.el-dialog__body) {
  border-top: 1px solid #dedede;
  padding: 15px 15px;
}
:deep(.tab-box) {

  margin-left:-15px;
  margin-right:-15px;
  .el-tabs{
    .el-tabs__header{
      padding-left:15px
    }
  }
}
.msg-list{
  max-height: 600px;
  overflow-y: auto;
  .msg-item{
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 15px 10px;
    &:hover{
      background-color: #efefef;
    }
    .msg-icon{
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #E7F0FB;
      border-radius: 40px;
      .el-icon-message-solid{
        color: #2B90FC;
        font-size: 18px;
      }
    }
    .msg-content{
      margin-left: 15px;
      .msg-type{
        color: #999;
        display: flex;
        align-items: center;
        span{
          margin-left: 10px;
          margin-right: 10px;
          font-size: 20px;
        }
      }
      .msg-tip{
        font-size: 16px;
        margin-top: 5px;
      }
    }
  }
}
.tabs-badge{
  background-color: #ff4949;
  border-radius: 10px;
  color: #fff;
  display: inline-block;
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  padding: 0 6px;
  text-align: center;
  white-space: nowrap;
  border: 1px solid #fff;
  position: absolute;
  top: -1px;
  right: -21px;
}
</style>
